// src/Components/LoadingSpinner/LoadingSpinner.js
import React from 'react';
import styles from './LoadingSpinner.module.css';

const LoadingSpinner = ({ size = 'medium', overlay = false }) => {
  const spinnerClass = `${styles.spinner} ${styles[size]} ${overlay ? styles.overlay : ''}`;
  
  return (
    <div className={overlay ? styles.overlayContainer : styles.container}>
      <div className={spinnerClass}>
        <div className={styles.bounce1}></div>
        <div className={styles.bounce2}></div>
        <div className={styles.bounce3}></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;